import type { TemaEspacio } from '../domain/types';

/**
 * Vuelca el tema del espacio a variables CSS del documento.
 *
 * Es lo que hace que Academia Bimbo y una futura Academia Treid sean la MISMA app: los
 * componentes usan `var(--azul)` y nunca un color literal, asi que cambiar de cliente es
 * cambiar una fila de configuracion. En fase 1 esa fila viene de `academia.espacios.tema`.
 */
export function aplicarTema(tema: TemaEspacio): void {
  const raiz = document.documentElement.style;
  raiz.setProperty('--azul', tema.azul);
  raiz.setProperty('--azul-osc', tema.azulOscuro);
  raiz.setProperty('--tinta', tema.tinta);
  raiz.setProperty('--rojo', tema.rojo);
  raiz.setProperty('--rojo-osc', tema.rojoOscuro);
  raiz.setProperty('--celeste', tema.celeste);
  raiz.setProperty('--cielo', tema.cielo);
  raiz.setProperty('--oro', tema.oro);
  raiz.setProperty('--verde', tema.verde);
  raiz.setProperty('--borde', tema.borde);
  raiz.setProperty('--gris', tema.gris);
  raiz.setProperty('--fuente-titulos', tema.fuenteTitulos);
  raiz.setProperty('--fuente-texto', tema.fuenteTexto);
}
